import { Component, Inject } from '@angular/core';
import { getConfiguration } from '@dcs-workspace/front-office/common';
import { ApmService } from '@dcs-workspace/shared';
import { Store } from '@ngrx/store';

@Component({
  selector: 'dcs-workspace-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private commonStore: Store,
    @Inject(ApmService) apmService: ApmService
  ) {
    this.commonStore.select(getConfiguration).subscribe((config) => {
      if (config.apmServiceName && config.apmServerUrl) {
        const apm = apmService.init({
          serviceName: config.apmServiceName,
          serverUrl: config.apmServerUrl,
        });

        apm.setUserContext({
          username: `anonymous`,
          id: '',
        });
      }
    });
  }
}
